var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.193,
    viewBox: "0 0 18 17.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3",
    transform: "translate(-2.15 -2.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710",
    transform: "translate(2.15 2.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M20.15,20.611H11.881a.731.731,0,1,1,0-1.461H20.15a.731.731,0,0,1,0,1.461Z",
    transform: "translate(-2.881 -3.419)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M16.663,2.029A2.68,2.68,0,0,1,18.558,6.6L7.073,18.088a.731.731,0,0,1-.339.192L3.058,19.2a.731.731,0,0,1-.886-.886l.919-3.675a.731.731,0,0,1,.192-.339L14.768,2.814A2.662,2.662,0,0,1,16.663,2.029ZM6.182,16.912,17.524,5.57A1.218,1.218,0,0,0,15.8,3.847L4.459,15.189l-.574,2.3Z",
    transform: "translate(-2.15 -2.029)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit3);
export default __webpack_public_path__ + "static/media/edit-3.6eab4b1c0bfca98b542231c0db7fa4b2.svg";
export { ForwardRef as ReactComponent };